module.exports = __webpack_public_path__ + "QA.png?8730854867a5b89b902e351a7b11e881";